import { Component, Input, OnInit } from '@angular/core';
import { AbstractModalComponent } from "../abstract-modal/abstract-modal.component";
import { BsModalRef } from "ngx-bootstrap/modal";
import { WarningModalService } from "../../services/warning-modal/warning-modal.service";

@Component({
  selector: 'app-multi-factor-authentication-modal',
  templateUrl: './multi-factor-authentication-modal.component.pug',
  styleUrls: ['./multi-factor-authentication-modal.component.scss'],
  standalone: false
})
export class MultiFactorAuthenticationModalComponent extends AbstractModalComponent implements OnInit {

  @Input() mfaEnabled: boolean = false;
  @Input() readOnly: boolean = false;

  mfaSettings: { enabled: boolean } = {
    enabled: false
  };
  saving = false;
  enabledText = $localize`Enabled`;
  disabledText = $localize`Disabled`;

  constructor(public _bsModalRef: BsModalRef, public modal: WarningModalService) {
    super(_bsModalRef, modal);
  }

  ngOnInit(): void {
    this.mfaSettings.enabled = this.mfaEnabled;
  }

  cancel() {
    if (this.readOnly) {
      this._bsModalRef.hide();
      return;
    }
    this.canDeactivate().subscribe(response => {
      if (response) {
        this.markAsPristine();
        this._bsModalRef.hide();
      }
    });
  }

  save() {
    if (this.readOnly) {
      return;
    }
    this.saving = true;
    this.messages = [];
    this.event.emit(this.mfaSettings);
  }

  getForm() {
    // Return a form-like object for AbstractModalComponent compatibility
    return { 
      dirty: this.formDirty, 
      form: { 
        markAsPristine: () => { this.formDirty = false; } 
      } 
    };
  }

  onMfaToggleChange(checked: boolean) {
    if (this.readOnly) {
      return;
    }
    this.mfaSettings.enabled = checked;
    this.formDirty = this.mfaSettings.enabled !== this.mfaEnabled;
  }

  closeModal() {
    this.cancel();
  }
}

